import { Injectable } from '@angular/core';
import { ApiService } from '@utility/http/api.service';
import { Coupon } from './coupon';

@Injectable({ providedIn: 'root' })
export class CouponService extends ApiService<Coupon> {
    protected baseUrl = 'coupons';
}
